import type {
  MapChangeStatus,
  MapChangeType,
  MapConfidence,
  MapTargetLane,
} from "../../enums/map";
import {
  MAP_CHANGE_STATUS,
  MAP_CHANGE_TYPE,
  MAP_CONFIDENCE,
  MAP_TARGET_LANE,
} from "../../enums/map";

export function mapChangeTypeLabel(value: MapChangeType): string {
  return {
    create_hub: "Create a hub or organising page",
    consolidate_pages: "Consolidate overlapping pages",
    improve_pattern: "Improve a page or content pattern",
    clarify_destination: "Clarify an onward destination",
    reorganise_group: "Reorganise a content group",
    retain_structure: "Retain the current structure",
    unresolved: "Leave unresolved",
  }[value];
}

export function mapStatusLabel(
  value: MapChangeStatus | "current",
  adjusted = false,
): string {
  if (value === "current") return "Current group";
  if (value === MAP_CHANGE_STATUS.ACCEPTED)
    return adjusted ? "Accepted / adjusted" : "Accepted in preview";
  if (value === MAP_CHANGE_STATUS.ADJUSTED) return "Adjusted draft";
  if (value === MAP_CHANGE_STATUS.UNRESOLVED) return "Needs context";
  if (value === MAP_CHANGE_STATUS.DISMISSED) return "Parked";
  return "Draft";
}

export function mapConfidenceLabel(value: MapConfidence): string {
  if (value === MAP_CONFIDENCE.STRONG) return "Strong evidence";
  if (value === MAP_CONFIDENCE.SOME) return "Some evidence";
  return "Limited evidence";
}

export function mapTargetLaneForType(
  value: MapChangeType,
  fallback: MapTargetLane,
): MapTargetLane {
  if (value === MAP_CHANGE_TYPE.CLARIFY_DESTINATION)
    return MAP_TARGET_LANE.DESTINATION;
  if (
    value === MAP_CHANGE_TYPE.CREATE_HUB ||
    value === MAP_CHANGE_TYPE.REORGANISE_GROUP ||
    value === MAP_CHANGE_TYPE.UNRESOLVED
  ) {
    return MAP_TARGET_LANE.ORGANISE;
  }
  if (value === MAP_CHANGE_TYPE.RETAIN_STRUCTURE) return fallback;
  return MAP_TARGET_LANE.PATTERN;
}

export function mapTargetRoleForType(
  value: MapChangeType,
  fallback: string,
): string {
  return {
    create_hub: "Section hub or organising page",
    consolidate_pages: "Combined page or content pattern",
    improve_pattern: "Page or content pattern",
    clarify_destination: "Clear onward destination",
    reorganise_group: "Content group",
    retain_structure: fallback,
    unresolved: "Role to confirm",
  }[value];
}

export const MAP_CHANGE_TYPES: MapChangeType[] = [
  MAP_CHANGE_TYPE.CREATE_HUB,
  MAP_CHANGE_TYPE.CONSOLIDATE_PAGES,
  MAP_CHANGE_TYPE.IMPROVE_PATTERN,
  MAP_CHANGE_TYPE.CLARIFY_DESTINATION,
  MAP_CHANGE_TYPE.REORGANISE_GROUP,
  MAP_CHANGE_TYPE.RETAIN_STRUCTURE,
  MAP_CHANGE_TYPE.UNRESOLVED,
];
